import { useState } from 'preact/hooks';
import { setToken } from '../api';
import { useLocation } from 'preact-iso';

export function Login() {
  const [value, setValue] = useState('');
  const [error, setError] = useState('');
  const { route } = useLocation();

  const handleSubmit = (e: Event) => {
    e.preventDefault();
    if (!value.trim()) {
      setError('Token required');
      return;
    }
    setToken(value.trim());
    route('/');
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'var(--bg)',
    }}>
      <form onSubmit={handleSubmit} style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        width: '360px',
      }}>
        <div style={{
          fontFamily: 'var(--hud)',
          fontSize: '24px',
          fontWeight: 700,
          color: 'var(--orange)',
          letterSpacing: '3px',
          textTransform: 'uppercase',
          textAlign: 'center',
        }}>
          TPA COMMAND CENTRE
        </div>
        <div style={{
          fontFamily: 'var(--mono)',
          fontSize: '11px',
          color: 'var(--text-dim)',
          textAlign: 'center',
          letterSpacing: '1px',
        }}>
          ENTER API BEARER TOKEN
        </div>
        <input
          type="password"
          value={value}
          onInput={(e) => setValue((e.target as HTMLInputElement).value)}
          placeholder="Bearer token..."
          style={{
            fontFamily: 'var(--mono)',
            fontSize: '13px',
            color: 'var(--peach)',
            background: '#0a0a0a',
            border: '1px solid var(--orange)',
            borderRadius: '4px',
            padding: '12px 16px',
            outline: 'none',
          }}
        />
        {error && (
          <div style={{ fontFamily: 'var(--mono)', fontSize: '11px', color: 'var(--red)' }}>
            {error}
          </div>
        )}
        <button
          type="submit"
          style={{
            fontFamily: 'var(--hud)',
            fontSize: '14px',
            fontWeight: 700,
            letterSpacing: '2px',
            textTransform: 'uppercase',
            padding: '10px 24px',
            background: 'var(--orange)',
            color: '#000',
            border: 'none',
            borderRadius: '20px',
            cursor: 'pointer',
          }}
        >
          Authenticate
        </button>
      </form>
    </div>
  );
}
